<template>
    <header>
    <section class="container">
        <div class="d-flex flex-column justify-content-center align-items-center">
            <span>
                {{ $t('faq.title') }}
            </span>
            <h1>
                {{ $t('faq.subtitle') }}
            </h1>
        </div>
    </section>
    <div class="abstract-3"></div>
</header>
</template>
<style lang="scss" scoped>
    header{
    padding-top: 60px;
    padding-bottom: 47px;
    background: #0c56760d;
    position: relative;
    text-align: center;
    span{
        color: #0f3c41cf;
        font-size: 18px;
        line-height: 18px;
        font-weight: 500;
    }
    h1{
        color: #0c668d;
        font-size: 25px;
        font-weight: 500;
        line-height: 22.063px; 
        margin-top: 20px;
        margin-bottom: 29px;
    }

}
</style>